// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card ── */
.odc-card {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fff;
  padding: 12px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  width: 100%;
}

@media (min-width: 640px) {
  .odc-card {
    padding: 16px;
  }
}

/* ── Header ── */
.odc-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f8fafc;
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.odc-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.odc-shipment-id {
  font-family: "Outfit", "Inter", monospace;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.odc-order-id {
  font-family: "Outfit", "Inter", monospace;
  font-size: 12px;
  color: #94a3b8;
}

.odc-status-badge {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  border: 1px solid transparent;
  padding: 2px 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: normal;
}

.odc-header-center {
  display: flex;
  align-items: center;
  gap: 8px;
}

.odc-provider {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}

.odc-vehicle {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #64748b;
}

.odc-vehicle b {
  color: #334155;
  font-weight: 600;
}

.odc-sep {
  color: #cbd5e1;
  margin-right: 2px;
}

.odc-header-right {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.odc-source-badge {
  border-radius: 20px;
  background: #f1f5f9;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #475569;
  letter-spacing: 0.04em;
}

.odc-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  border: 1px solid transparent;
  font-family: "Outfit", "Inter", sans-serif;
}

.odc-btn-icon:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.odc-btn-refresh {
  width: 28px;
  height: 28px;
  background: #eff6ff;
  color: #2563eb;
  border: none;
}

.odc-btn-refresh:hover:not(:disabled) {
  background: #dbeafe;
}

.odc-btn-cancel {
  height: 28px;
  padding: 0 8px;
  border-color: #fecdd3;
  color: #e11d48;
  background: #fff;
}

.odc-btn-cancel:hover:not(:disabled) {
  background: #fff1f2;
}

.odc-spin {
  animation: odc-spin 1s linear infinite;
}

@keyframes odc-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Grid ── */
.odc-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 1024px) {
  .odc-grid {
    grid-template-columns: 8fr 4fr;
    gap: 24px;
  }
}

/* ── Left column ── */
.odc-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Location row */
.odc-location-row {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (min-width: 768px) {
  .odc-location-row {
    /* flex-direction: row; */
    gap: 10px;
  }
}

.odc-location-line {
  position: absolute;
  bottom: 12px;
  left: 9px;
  top: 12px;
  width: 2px;
  background: #e2e8f0;
  z-index: 0;
}

@media (min-width: 768px) {
  .odc-location-line {
    bottom: auto;
    left: 12px;
    right: 12px;
    top: 9px;
    height: 2px;
    width: auto;
  }
}

.odc-location-item {
  display: flex;
  gap: 12px;
  flex: 1;
  background: #fff;
  padding-right: 8px;
}

@media (min-width: 768px) {
  .odc-location-item:last-child {
    /* padding-left: 8px; */
    padding-right: 0;
  }
}

.odc-dot {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.odc-dot-green {
  background: #10b981;
  border-color: #d1fae5;
}

.odc-dot-rose {
  background: #f43f5e;
  border-color: #ffe4e6;
}

.odc-loc-title {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}

.odc-loc-addr {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Progress card */
.odc-progress-card {
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  background: #f8fafc;
  padding: 12px;
}

.odc-progress-header {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 8px;
}

.odc-eta {
  color: #0f172a;
}

.odc-eta b {
  font-weight: 700;
}

.odc-progress-bar {
  height: 6px;
  background: #007bff33;
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 8px;
}

.odc-progress-fill {
  height: 100%;
  background: #2563eb;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.odc-tracking-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #2563eb;
  text-decoration: none;
}

.odc-tracking-link:hover {
  text-decoration: underline;
}

/* Show more */
.odc-show-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0066ff;
  cursor: pointer;
  transition: color 0.15s ease;
  font-family: "Outfit", "Inter", sans-serif;
}

.odc-show-more:hover {
  color: #0052cc;
}

/* ── Right column ── */
.odc-right {
  display: flex;
  /* flex-direction: column; */
  gap: 16px;
}

@media (min-width: 1024px) {
  .odc-right {
    border-left: 1px solid #f1f5f9;
    padding-left: 24px;
  }
}

.odc-side-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
}

.odc-side-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.odc-side-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
  margin: 0;
}

.odc-side-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.odc-side-name {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  margin: 0;
}

.odc-side-phone {
  font-size: 11px;
  color: #64748b;
  margin: 0;
}

.odc-charges {
  border-top: 1px solid #f8fafc;
  padding-top: 8px;
  font-size: 11px;
  color: #64748b;
  display: flex;
  justify-content: space-between;
}

.odc-charge-value {
  font-weight: 500;
  color: #0f172a;
}

/* Kebab */
.odc-kebab {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #cbd5e1;
  display: inline-flex;
  align-items: center;
}

.odc-kebab:hover {
  color: #475569;
}

/* Icons */
.odc-icon-sm {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.odc-icon-xs {
  width: 12px;
  height: 12px;
}

.odc-icon-side {
  width: 14px;
  height: 14px;
  color: #94a3b8;
  flex-shrink: 0;
  margin-top: 2px;
}

.odc-icon-kebab {
  width: 16px;
  height: 16px;
}

/* ── Status badge colours (shared with old names) ── */
.tpl-status-created,
.tpl-status-pending {
  background: #f1f5f9;
  color: #475569;
}

.tpl-status-assigned {
  background: #eff6ff;
  color: #1d4ed8;
}

.tpl-status-picked {
  background: #fdf2f8;
  color: #be185d;
}

.tpl-status-transit {
  background: #fff7ed;
  color: #c2410c;
}

.tpl-status-arrived {
  background: #fefce8;
  color: #a16207;
}

.tpl-status-delivered {
  background: #f0fdf4;
  color: #15803d;
}

.tpl-status-cancelled {
  background: #fef2f2;
  color: #dc2626;
}

/* ── Popover menu (kept from original) ── */
.edit-product-item-container {
  color: var(--Gray-900, #181d28);
}

.edit-product-item-container-2 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
}

.edit-product-item-container-1 {
  padding: 0.75rem;
  border-bottom: 1px solid var(--Gray-200, #e9eaec);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.product-edit-modal-icon {
  height: 1.25rem;
  width: 1.5rem;
  color: var(--Surface-g5, #333);
  margin-top: -5px;
  cursor: pointer;
}

.product-edit-modal-icon svg {
  width: auto;
  height: 1.25rem;
}

.tpl-location-icon {
  width: 18px;
  height: 18px;
}

/* ── OrderDetailsModal (odm___) ──────────────────────────────────── */
.odm___backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  z-index: 1299;
}

.odm___drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 80%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: -4px 0 32px rgba(15, 23, 42, 0.15);
  z-index: 1300;
  overflow: hidden;
}

.odm___drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  background: #fff;
}

.odm___drawer-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  flex-shrink: 0;
}

.odm___close-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.odm___drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.odm___meta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___meta-shipment-id {
  font-weight: 700;
  color: #0f172a;
}

.odm___meta-order-id {
  color: #64748b;
}

.odm___meta-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.odm___meta-divider {
  width: 1px;
  height: 16px;
  background: #e2e8f0;
  flex-shrink: 0;
}

.odm___meta-provider {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #334155;
}

.odm___meta-vehicle {
  font-size: 13px;
  color: #64748b;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___meta-vehicle strong {
  color: #334155;
}

.odm___meta-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.odm___meta-source {
  border-radius: 4px;
  background: #f1f5f9;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #475569;
  letter-spacing: 0.04em;
}

.odm___meta-duration {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 13px;
}

.odm___duration-highlight {
  color: #1d4ed8;
  font-size: 15px;
}

.odm___cards-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.odm___detail-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 20px;
}

.odm___card-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: #475569;
}

.odm___card-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___card-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.odm___field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.odm___field-label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 2px;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___field-value {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
}

.odm___vehicle-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.odm___vehicle-number {
  color: #64748b;
  font-weight: 400;
}

.odm___location-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.odm___actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.odm___action-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.odm___btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Outfit", "Inter", sans-serif;
  white-space: nowrap;
  background: #fff;
  transition: background 0.15s ease;
}

.odm___btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.odm___btn-blue {
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
}

.odm___btn-blue:hover:not(:disabled) {
  background: #eff6ff;
}

.odm___btn-slate {
  border: 1px solid #e2e8f0;
  color: #334155;
}

.odm___btn-slate:hover:not(:disabled) {
  background: #f8fafc;
}

.odm___btn-rose {
  border: 1px solid #fecdd3;
  color: #e11d48;
}

.odm___btn-rose:hover:not(:disabled) {
  background: #fff1f2;
}

.odm___expected-arrival {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  font-family: "Outfit", "Inter", sans-serif;
  white-space: nowrap;
}

.odm___arrival-time {
  color: #1d4ed8;
  font-weight: 700;
}

.odm___timeline-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 24px;
}

.odm___timeline-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
  margin-bottom: 24px;
}

.odm___empty {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  color: #94a3b8;
  font-size: 14px;
  font-family: "Outfit", "Inter", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/ThirdPartyLogistics/components/OrderDetailsCard.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;EAClB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,yBAAyB;IACzB,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uDAAuD;AACvD;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;;oBAEkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,0CAA0C;AAC5C","sourcesContent":["/* ── Card ── */\n.odc-card {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #fff;\n  padding: 12px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .odc-card {\n    padding: 16px;\n  }\n}\n\n/* ── Header ── */\n.odc-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid #f8fafc;\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n}\n\n.odc-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.odc-shipment-id {\n  font-family: \"Outfit\", \"Inter\", monospace;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.odc-order-id {\n  font-family: \"Outfit\", \"Inter\", monospace;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.odc-status-badge {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  padding: 2px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: normal;\n}\n\n.odc-header-center {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.odc-provider {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.odc-vehicle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.odc-vehicle b {\n  color: #334155;\n  font-weight: 600;\n}\n\n.odc-sep {\n  color: #cbd5e1;\n  margin-right: 2px;\n}\n\n.odc-header-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.odc-source-badge {\n  border-radius: 20px;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #475569;\n  letter-spacing: 0.04em;\n}\n\n.odc-btn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n  border: 1px solid transparent;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odc-btn-icon:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.odc-btn-refresh {\n  width: 28px;\n  height: 28px;\n  background: #eff6ff;\n  color: #2563eb;\n  border: none;\n}\n\n.odc-btn-refresh:hover:not(:disabled) {\n  background: #dbeafe;\n}\n\n.odc-btn-cancel {\n  height: 28px;\n  padding: 0 8px;\n  border-color: #fecdd3;\n  color: #e11d48;\n  background: #fff;\n}\n\n.odc-btn-cancel:hover:not(:disabled) {\n  background: #fff1f2;\n}\n\n.odc-spin {\n  animation: odc-spin 1s linear infinite;\n}\n\n@keyframes odc-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Grid ── */\n.odc-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .odc-grid {\n    grid-template-columns: 8fr 4fr;\n    gap: 24px;\n  }\n}\n\n/* ── Left column ── */\n.odc-left {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Location row */\n.odc-location-row {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n@media (min-width: 768px) {\n  .odc-location-row {\n    /* flex-direction: row; */\n    gap: 10px;\n  }\n}\n\n.odc-location-line {\n  position: absolute;\n  bottom: 12px;\n  left: 9px;\n  top: 12px;\n  width: 2px;\n  background: #e2e8f0;\n  z-index: 0;\n}\n\n@media (min-width: 768px) {\n  .odc-location-line {\n    bottom: auto;\n    left: 12px;\n    right: 12px;\n    top: 9px;\n    height: 2px;\n    width: auto;\n  }\n}\n\n.odc-location-item {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n  background: #fff;\n  padding-right: 8px;\n}\n\n@media (min-width: 768px) {\n  .odc-location-item:last-child {\n    /* padding-left: 8px; */\n    padding-right: 0;\n  }\n}\n\n.odc-dot {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border-width: 3px;\n  border-style: solid;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.odc-dot-green {\n  background: #10b981;\n  border-color: #d1fae5;\n}\n\n.odc-dot-rose {\n  background: #f43f5e;\n  border-color: #ffe4e6;\n}\n\n.odc-loc-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.odc-loc-addr {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Progress card */\n.odc-progress-card {\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  background: #f8fafc;\n  padding: 12px;\n}\n\n.odc-progress-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.odc-eta {\n  color: #0f172a;\n}\n\n.odc-eta b {\n  font-weight: 700;\n}\n\n.odc-progress-bar {\n  height: 6px;\n  background: #007bff33;\n  border-radius: 999px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.odc-progress-fill {\n  height: 100%;\n  background: #2563eb;\n  border-radius: 999px;\n  transition: width 0.3s ease;\n}\n\n.odc-tracking-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.odc-tracking-link:hover {\n  text-decoration: underline;\n}\n\n/* Show more */\n.odc-show-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0066ff;\n  cursor: pointer;\n  transition: color 0.15s ease;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odc-show-more:hover {\n  color: #0052cc;\n}\n\n/* ── Right column ── */\n.odc-right {\n  display: flex;\n  /* flex-direction: column; */\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .odc-right {\n    border-left: 1px solid #f1f5f9;\n    padding-left: 24px;\n  }\n}\n\n.odc-side-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n}\n\n.odc-side-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.odc-side-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.odc-side-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.odc-side-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  margin: 0;\n}\n\n.odc-side-phone {\n  font-size: 11px;\n  color: #64748b;\n  margin: 0;\n}\n\n.odc-charges {\n  border-top: 1px solid #f8fafc;\n  padding-top: 8px;\n  font-size: 11px;\n  color: #64748b;\n  display: flex;\n  justify-content: space-between;\n}\n\n.odc-charge-value {\n  font-weight: 500;\n  color: #0f172a;\n}\n\n/* Kebab */\n.odc-kebab {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #cbd5e1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.odc-kebab:hover {\n  color: #475569;\n}\n\n/* Icons */\n.odc-icon-sm {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.odc-icon-xs {\n  width: 12px;\n  height: 12px;\n}\n\n.odc-icon-side {\n  width: 14px;\n  height: 14px;\n  color: #94a3b8;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.odc-icon-kebab {\n  width: 16px;\n  height: 16px;\n}\n\n/* ── Status badge colours (shared with old names) ── */\n.tpl-status-created,\n.tpl-status-pending {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.tpl-status-assigned {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.tpl-status-picked {\n  background: #fdf2f8;\n  color: #be185d;\n}\n\n.tpl-status-transit {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.tpl-status-arrived {\n  background: #fefce8;\n  color: #a16207;\n}\n\n.tpl-status-delivered {\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.tpl-status-cancelled {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n/* ── Popover menu (kept from original) ── */\n.edit-product-item-container {\n  color: var(--Gray-900, #181d28);\n}\n\n.edit-product-item-container-2 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.edit-product-item-container-1 {\n  padding: 0.75rem;\n  border-bottom: 1px solid var(--Gray-200, #e9eaec);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.product-edit-modal-icon {\n  height: 1.25rem;\n  width: 1.5rem;\n  color: var(--Surface-g5, #333);\n  margin-top: -5px;\n  cursor: pointer;\n}\n\n.product-edit-modal-icon svg {\n  width: auto;\n  height: 1.25rem;\n}\n\n.tpl-location-icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* ── OrderDetailsModal (odm___) ──────────────────────────────────── */\n.odm___backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.4);\n  z-index: 1299;\n}\n\n.odm___drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 80%;\n  max-width: 1100px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  box-shadow: -4px 0 32px rgba(15, 23, 42, 0.15);\n  z-index: 1300;\n  overflow: hidden;\n}\n\n.odm___drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 64px;\n  padding: 0 24px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.odm___drawer-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.odm___close-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.odm___drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.odm___meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___meta-shipment-id {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.odm___meta-order-id {\n  color: #64748b;\n}\n\n.odm___meta-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.odm___meta-divider {\n  width: 1px;\n  height: 16px;\n  background: #e2e8f0;\n  flex-shrink: 0;\n}\n\n.odm___meta-provider {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.odm___meta-vehicle {\n  font-size: 13px;\n  color: #64748b;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___meta-vehicle strong {\n  color: #334155;\n}\n\n.odm___meta-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.odm___meta-source {\n  border-radius: 4px;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #475569;\n  letter-spacing: 0.04em;\n}\n\n.odm___meta-duration {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.odm___duration-highlight {\n  color: #1d4ed8;\n  font-size: 15px;\n}\n\n.odm___cards-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.odm___detail-card {\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 20px;\n}\n\n.odm___card-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  color: #475569;\n}\n\n.odm___card-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___card-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.odm___field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.odm___field-label {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 2px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___field-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.odm___vehicle-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.odm___vehicle-number {\n  color: #64748b;\n  font-weight: 400;\n}\n\n.odm___location-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.odm___actions-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.odm___action-btns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.odm___btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 14px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  white-space: nowrap;\n  background: #fff;\n  transition: background 0.15s ease;\n}\n\n.odm___btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.odm___btn-blue {\n  border: 1px solid #bfdbfe;\n  color: #1d4ed8;\n}\n\n.odm___btn-blue:hover:not(:disabled) {\n  background: #eff6ff;\n}\n\n.odm___btn-slate {\n  border: 1px solid #e2e8f0;\n  color: #334155;\n}\n\n.odm___btn-slate:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.odm___btn-rose {\n  border: 1px solid #fecdd3;\n  color: #e11d48;\n}\n\n.odm___btn-rose:hover:not(:disabled) {\n  background: #fff1f2;\n}\n\n.odm___expected-arrival {\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  white-space: nowrap;\n}\n\n.odm___arrival-time {\n  color: #1d4ed8;\n  font-weight: 700;\n}\n\n.odm___timeline-card {\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 24px;\n}\n\n.odm___timeline-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  margin-bottom: 24px;\n}\n\n.odm___empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n  color: #94a3b8;\n  font-size: 14px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
